import {
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuSub,
} from "@components/ui/sidebar";
import { ChevronRightIcon } from "lucide-react";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@components/ui/collapsible";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { SearchLight } from "@/types/Search";
import { SearchItem } from "./SearchItem";

export function InactiveSearches({
  inactiveSearches,
  orgUuid,
  pathname,
  onDelete,
}: {
  inactiveSearches: SearchLight[];
  orgUuid: string;
  pathname: string;
  onDelete: (searchUuid: string) => void;
}) {
  const [isOpen, setIsOpen] = useLocalStorage(
    "sidebar-inactive-searches-open",
    false
  );

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="group/inactive-searches"
    >
      <SidebarMenuItem>
        <CollapsibleTrigger
          render={<SidebarMenuButton className="text-muted-foreground" />}
        >
          <Trans>Inaktiva bevakningar</Trans>
          <ChevronRightIcon className="ml-auto transition-transform group-data-open/inactive-searches:rotate-90" />
        </CollapsibleTrigger>
      </SidebarMenuItem>

      <CollapsibleContent>
        <SidebarMenuSub>
          {inactiveSearches.map((search) => {
            const to = ROUTES.ARCHIVE_DETAIL_ORGID.replace(
              ":orgUuid",
              orgUuid
            ).replace(":uuid", search.uuid);

            return (
              <SearchItem
                key={search.uuid}
                to={to}
                isInSubMenu
                search={search}
                orgUuid={orgUuid}
                pathname={pathname}
                onDelete={() => onDelete(search.uuid)}
              />
            );
          })}
        </SidebarMenuSub>
      </CollapsibleContent>
    </Collapsible>
  );
}
